<template>
  <div>
    <button type="button" class="icon-btn" title="Add category" @click="$bvModal.show(modalId)">
      <feather type="plus" size="16"></feather>
    </button>
    <b-modal size="xl" :id="modalId" title="Category Add" hide-footer @show="OnShowModal" @hide="clear"
      no-close-on-esc no-close-on-backdrop>
      <div class="container-fluid">
        <b-modal ref="alert" title="Admin" @ok="close()" ok-only>
          <p class="my-4">{{ message }}</p>
        </b-modal>
        <div class="row product-adding">
          <div class="col-xl-12">
            <b-card no-body>
              <b-card-text>
                <div class="digital-add needs-validation">
                  <div class="form-group">
                    <label for="validationcategoryname" class="col-form-label pt-0">Category name <span>*</span></label>
                    <ValidationProvider name="categoryen" rules="required" v-slot="{ errors }">
                      <input class="form-control" id="validationcategoryname" type="text" v-model="category"
                        required="" />
                      <span class="block text-danger text-xs absolute bottom-0 left-0">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <label>Category description</label>
                  <vue-editor v-model="description"></vue-editor>
                  <br />
                  <div class="form-group">
                    <label for="validationoffer" class="col-form-label pt-0">Offer</label>
                    <input class="form-control" id="validationoffer" type="text" v-model="offer" required="" />
                  </div>
                  <div class="form-group">
                    <label class="col-form-label pt-0">Banner Upload <span>*</span></label>
                    <vue-dropzone id="addCat" :options="AddCatOptions" class="dropzone digits" ref="AddCat"
                      :useCustomSlot="true" v-on:vdropzone-success="uploadSuccess"
                      v-on:vdropzone-removed-file="fileRemoved" @vdropzone-complete="uploadComplete"
                      @vdropzone-sending="sending" @vdropzone-error="uploadError">
                    </vue-dropzone>
                  </div>
                  <div class="form-group">
                    <label for="validationmetatitle" class="col-form-label pt-0">Meta title</label>
                    <input class="form-control" id="validationmetatitle" type="text" v-model="metatitle" required="" />
                  </div>
                  <div class="form-group">
                    <label for="validationmetadescription" class="col-form-label pt-0">Meta description</label>
                    <input class="form-control" id="validationmetadescription" type="text" v-model="metadescription"
                      required="" />
                  </div>
                  <div class="form-group">
                    <label for="validationmetadescription" class="col-form-label pt-0">Meta keywords</label>
                    <input class="form-control" id="validationmetadescription" type="text" v-model="metakeywords"
                      required="" />
                  </div>
                </div>
              </b-card-text>
            </b-card>
          </div>
        </div>
        <div class="col-xl-12 pb-3">
          <div class="form-group mb-0">
            <div class="product-buttons text-right">
              <button type="button" class="btn btn-light mr-2" @click="back">
                Cancel
              </button>
              <button type="button" class="btn btn-primary" @click="save">
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Container-fluid Ends-->
    </b-modal>
  </div>
</template>
<script>
import firebase from '@/utils/firestore-shim';
import { uploadUrl, uploadHeaders, reportUploadError } from './../../../utils/imageUpload';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { uuid } from "vue-uuid";
export default {
  props: {
    host: String,
    // Identifiant du modal : distinct pour le second bouton « + » affiché
    // sur mobile, afin que chaque bouton ouvre son propre modal.
    modalId: { type: String, default: "modal-CategoryAdd" }
  },
  data() {
    return {
      category: "",
      description: "",
      image: "",
      offer: "",
      metaTitle: "",
      metaDescription: "",
      metaKeywords: "",
      message: "",
      error: 0,
      editor: ClassicEditor,
      filter: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      index: null,
      selectMode: "single",
      banner: null,
      AddCatOptions: {
        url: uploadUrl,
        headers: uploadHeaders(),
        thumbnailWidth: 250,
        thumbnailHeight: 250,
        maxFiles: 1,
        maxfilesexceeded: function (file) {
          this.removeAllFiles();
          this.addFile(file);
        },
        accept: function (file, done) {
          done();
        },
        init: function () {
          this.on("removedfile", function (file) {
            return null;
          });
        },
        maxFilesize: 100,
        addRemoveLinks: true,
        uploadMultiple: false,
        maxThumbnailFilesize: 20,
        dictDefaultMessage:
          "<i class='icon-cloud-up'></i><h6>Drop files here or click to upload. 150 x 50 px</h6><</span>",
      },
    };
  },
  methods: {
    save() {
      if (this.category == "") {
        this.message = "Please complete all required fields!";
        this.error = 1;
        this.$refs['alert'].show()
        return false;
      } else {
        this.error = 0;
      }
      if (this.error == 1) {
        this.message = "Error writing document!";
        this.error = 1;
        this.$refs['alert'].show();
        return false;
      }
      let form = {
        category: this.category.toUpperCase(),
        description: this.description,
        image: this.image,
        offer: this.offer,
        metaTitle: this.metatitle,
        metaDescription: this.metadescription,
        metaKeywords: this.metakeywords
        
      }
      this.$emit('ok', form);
      this.$bvModal.hide(this.modalId);
    },
    close() {
      if (this.error == 0) this.$bvModal.hide(this.modalId);
    },
    back() {
      this.$bvModal.hide(this.modalId);
    },
    clear() {

    },
    OnShowModal() {
      this.category = "";
      this.description = "";
      this.image = "";
      this.offer = "";
      this.metatitle = "";
      this.metadescription = "";
      this.metakeywords = "";
    },
    uploadComplete(file, response) {
      // L'API renvoie directement { url: '/uploads/...' } : l'image est
      // déjà stockée sur le serveur, plus besoin de renvoyer l'aperçu.
      try {
        var data = typeof response === 'string' ? JSON.parse(response) : (response || {});
        this.image = data.url;
      } catch (e) {
        reportUploadError(this, e.message);
      }
    },
    fileRemoved() {

    },
    uploadSuccess() {

    },
    uploadError(file, message) {
      reportUploadError(this, message);
    },
    sending(file, xhr, formData) {
      // Juste avant l'envoi : indique à l'API le dossier de stockage.
      formData.append('folder', 'sites/' + this.host + '/categories');
    }
  }
};
</script>
<style lang="scss" scoped></style>